import { PlanningBalancesByPeriodsQuery } from 'generated/resources/graphql'
import moment from 'moment'

import { ShiftsRow } from 'modules/shift_management/lib/types'

type TimePlanningBalancesByPeriod = NonNullable<
  PlanningBalancesByPeriodsQuery['timePlanning']['balancesByPeriodsConnection']['nodes']
>[number]

const overPlannedHoursCalculator = (
  shiftsRow: ShiftsRow,
  periodBalances: TimePlanningBalancesByPeriod[],
  maximumWeeklyHoursInCents?: number
) => {
  if (!maximumWeeklyHoursInCents)
    return {
      overPlannedPeriods: [],
      maximumWeeklyHours: 0,
    }

  // We get the maximum weekly hours in cents, so we need to divide by 100 to get the hours,
  // then convert to milliseconds, since duration is in milliseconds
  const maximumWeeklyHours = maximumWeeklyHoursInCents / 100
  const maximumWeeklyHoursInMilliseconds = (maximumWeeklyHours || 0) * 60 * 60 * 1000

  const durations = periodBalances.map((period) => {
    const duration = shiftsRow.hoursPerRangeAsMilliseconds(
      moment(period.startAt).clone().startOf('day'),
      moment(period.endAt).clone().endOf('day')
    )

    const leaveHoursInMilliseconds = (period.leaveHours ?? 0) * 60 * 60 * 1000
    const bankHolidayHoursInMilliseconds = (period.bankHolidayHours ?? 0) * 60 * 60 * 1000

    const maxPeriodDuration = Math.max(
      0,
      maximumWeeklyHoursInMilliseconds - leaveHoursInMilliseconds - bankHolidayHoursInMilliseconds
    )

    return {
      ...period,
      week: moment(period.startAt).clone().week(),
      isOverMaximum: duration > maxPeriodDuration,
    }
  })

  return {
    overPlannedPeriods: durations.filter((duration) => duration.isOverMaximum),
    maximumWeeklyHours,
  }
}

export default overPlannedHoursCalculator
